"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListObjectsInput_1 = require("./ListObjectsInput");
var ListObjectsOutput_1 = require("./ListObjectsOutput");
var NoSuchBucket_1 = require("./NoSuchBucket");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListObjects = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListObjects",
    http: {
        method: "GET",
        requestUri: "/{Bucket}"
    },
    input: {
        shape: ListObjectsInput_1.ListObjectsInput
    },
    output: {
        shape: ListObjectsOutput_1.ListObjectsOutput
    },
    errors: [
        {
            shape: NoSuchBucket_1.NoSuchBucket
        }
    ]
};
//# sourceMappingURL=ListObjects.js.map